module.exports = __webpack_public_path__ + "img/commandpost_driving.43c5fd21.svg";